import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
  version,
} from "react";
import "./newPartRequest.css";
import { Wrapper } from "../../../../../components/Wrapper/Wrapper";
import { Link, Tooltip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { NavBar } from "../../../../../components/NavBar/NavBar";
import { dropdownConfig } from "../../../../../services/dropdownsConfigService";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
import { Dropdowns } from "../../../../../components/Dropdowns/Dropdowns";
import BasicDatePicker from "../../../../../components/Datepicker/Datepicker";
import { NewPartRequestTC } from "../NewPartRequestTC/NewPartRequestTC";
import { environment } from "../../../../../environments/environment";
import Skeleton from "react-loading-skeleton";
import {
  getPermissions,
  getUserCompanyId,
} from "../../../../../services/authService";
import { useSnackBar } from "../../../../../hooks/useSnackBar";
import {
  createPartRequest,
  getPRNEditionForm,
  savePartRequest,
} from "../../../Services/partRequestService.jsx";
import { useDropdownGlobalData } from "../../../../../contexts/DropdownGlobalDataContext.jsx";
import Input from "../../../../../components/Inputs/Input.jsx";
import { useDispatch } from "react-redux";
import {
  addTab,
  clearActiveTab,
  closeTab,
  setActiveTab,
} from "../../../../../redux/features/TabsManager/tabSlice.js";
import { useAliveController } from "react-activation";
import { PermissionsProvider } from "../../../../../contexts/PermissionsContext.jsx";
import iconSend from "../../../../../assets/Icons/paper_airplane.svg";
import { useNewPartRequestContext } from "../../../context/NewPartRequestContext.jsx";

const basePath = environment.basePath;
const currentDate = new Date().toISOString().split("T")[0];
let isKeyDownListenerAttached = false;
let keyDownHandler = null;

export const NewPartRequest = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const requestId = queryParams.get("req_id");
  const formMode = queryParams.get("mode");
  const dataBreadCrumbs = [
    <Link
      key={1}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => navigate(basePath + "/customdashboard")}
    >
      Modules
    </Link>,
    <Link
      key={2}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => navigate(basePath + "/store")}
    >
      Stores
    </Link>,
    <Link
      key={3}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => navigate(basePath + "/store/part-request-management")}
    >
      Part Request Management
    </Link>,
    <Link
      key={3}
      underline="none"
      sx={{ color: "#000000", cursor: "default", fontSize: "var(--p-size)" }}
    >
      {formMode === "edit" ? "Edit Part Request" : "New Part Request"}
    </Link>,
  ];

  const dispatch = useDispatch();

  const [version, setVersion] = useState(0);
  const [prnStatus, setPrnStatus] = useState(null);
  const [form, setForm] = useState(null);
  const [PRN, setPRN] = useState(null);
  const [locationDrop, setLocationDrop] = useState(null);
  const [siteDrop, setSiteDrop] = useState(null);
  const [aircraftDrop, setAircraftDrop] = useState(null);
  const [companyDrop, setCompanyDrop] = useState(null);
  const [customerDrop, setCustomerDrop] = useState(null);
  const [WPDrop, setWPDrop] = useState(null);
  const [requestTypeDrop, setRequestTypeDrop] = useState(null);
  const [priorityDrop, setPriorityDrop] = useState(null);

  const [selectedCompany, setSelectedCompany] = useState(
    parseInt(getUserCompanyId())
  );
  const [locationSelected, setLocationSelected] = useState(null);
  const [siteSelected, setSiteSelected] = useState(null);
  const [aircraftSelected, setAircraftSelected] = useState(null);
  const [dateRequiredSelected, setDateRequiredSelected] = useState(currentDate);
  const [dateRequestedCreated, setDateRequestedCreated] = useState(null);
  const [customerSelected, setCustomerSelected] = useState(null);
  const [prioritySelected, setPrioritySelected] = useState(null);
  const [preselectPriority, setPreselectPriority] = useState(null);

  const [dataCompanyDrop, setDataCompanyDrop] = useState([]);
  const { successMsg, errorMsg, warningMsg, infoMsg } = useSnackBar();
  const [WPCards, setWPCards] = useState([]);
  const [WPSelected, setWPSelected] = useState(null);

  const [hasCompanyError, setHasCompanyError] = useState(false);
  const [hasLocationError, setHasLocationError] = useState(false);
  const [hasSiteError, setHasSiteError] = useState(false);
  const [hasAircraftError, setHasAircraftError] = useState(false);
  const [hasWPError, setHasWPError] = useState(false);
  const [hasDateRequiredError, setHasDateRequiredError] = useState(false);
  const { updateWPSelectionContext } = useDropdownGlobalData();

  const [preselectCompany, setPreselectCompany] = useState(
    parseInt(getUserCompanyId())
  );
  const [preselectLocation, setPreselectLocation] = useState("");
  const [preselectSite, setPreselectSite] = useState("");
  const [preselectAircraft, setPreselectAircraft] = useState("");
  const [preselectWP, setPreselectWP] = useState("");
  const [preselectCustoner, setPreselectCustomer] = useState("");
  const [hasPermissionsToDraft, setHasPermissionsToDraft] = useState(false);
  const [hasPermissionsToPost, setHasPermissionsToPost] = useState(false);
  const [hasPermissionsToTC, setHasPermissionsToTC] = useState(false);
  const [hasPermissionsToFND, setHasPermissionsToFND] = useState(false);
  const [disablePostBtn, setDisablePastBtn] = useState(true);
  const { notifySaved } = useNewPartRequestContext();

  // functions

  const getDropdownConfigLocations = async () => {
    let id = 17;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setLocationDrop(request.data.load);
    }
  };

  const getDropdownConfigSites = async () => {
    let id = 19;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setSiteDrop(request.data.load);
    }
  };

  const getDropdownConfigAircraft = async () => {
    let id = 66;
    // let id = 51;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setAircraftDrop(request.data.load);
    }
  };

  const getDropdownConfigCompany = async () => {
    let id = 61;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setCompanyDrop(request.data.load);
    }
  };

  const getDropdownConfigCustomer = async () => {
    let id = 63;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setCustomerDrop(request.data.load);
    }
  };

  const getDropdownConfigWP = async () => {
    let id = 65;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setWPDrop(request.data.load);
    }
  };

  const getDropdownConfigRequestType = async () => {
    let id = 105;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setRequestTypeDrop(request.data.load);
    }
  };
  const getDropdownConfigPriority = async () => {
    let id = 107;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setPriorityDrop(request.data.load);
    }
  };

  const getAllDropdowns = async () => {
    const results = await Promise.all([
      getDropdownConfigLocations(),
      getDropdownConfigSites(),
      getDropdownConfigAircraft(),
      getDropdownConfigCompany(),
      getDropdownConfigCustomer(),
      getDropdownConfigWP(),
      getDropdownConfigRequestType(),
      getDropdownConfigPriority(),
    ]);

    return results;
  };

  const validateTcAndPNData = (wpcards) => {
    let isValid = true;

    // 1. Validar si hay WPCards
    if (!wpcards || wpcards.length === 0) {
      setDisablePastBtn(true);
      isValid = false;
      return isValid;
    }

    for (let i = 0; i < wpcards.length; i++) {
      const card = wpcards[i];

      if (
        !card.partRequestDetailParts ||
        card.partRequestDetailParts.length === 0
      ) {
        setDisablePastBtn(true);
        isValid = false;
      }

      if (
        (card.taskCardId === null && card.findingId === null) ||
        (card.taskCardId !== null && card.findingId !== null)
      ) {
        setDisablePastBtn(true);
        isValid = false;
      }

      for (let j = 0; j < card.partRequestDetailParts?.length; j++) {
        const part = card.partRequestDetailParts[j];

        if (!part.partId) {
          setDisablePastBtn(true);
          isValid = false;
        }

        if (
          part.quantity === null ||
          part.quantity === undefined ||
          part.quantity <= 0 ||
          isNaN(part.quantity)
        ) {
          setDisablePastBtn(true);
          isValid = false;
        }
      }
    }

    if (isValid) {
      setDisablePastBtn(false);
    }

    return isValid;
  };

  useEffect(() => {
    validateTcAndPNData(WPCards);
  }, [form]);

  const ValidateForm = () => {
    let isValid = true;

    if (!selectedCompany) {
      setHasCompanyError(true);
      setDisablePastBtn(true);
      isValid = false;
    } else {
      setHasCompanyError(false);
    }

    if (!locationSelected) {
      setHasLocationError(true);
      setDisablePastBtn(true);
      isValid = false;
    } else {
      setHasLocationError(false);
    }

    if (!siteSelected) {
      setHasSiteError(true);
      setDisablePastBtn(true);

      isValid = false;
    } else {
      setHasSiteError(false);
    }

    // if (!aircraftSelected) {
    //     setHasAircraftError(true);
    //     isValid = false;
    // } else {
    //     setHasAircraftError(false);
    // }

    if (!dateRequiredSelected) {
      setHasDateRequiredError(true);
      setDisablePastBtn(true);

      isValid = false;
    } else {
      setHasDateRequiredError(false);
    }

    if (!WPSelected) {
      setHasWPError(true);
      isValid = false;
    } else {
      setHasWPError(false);
    }

    // if (!WPCards.length || WPCards.length === 0) {
    //     setHasWPError(true);
    //     isValid = false;
    // } else {
    //     setHasWPError(false);
    // }

    if (!isValid) {
      warningMsg(
        "Fields required",
        "Make Sure You Have Selected All Fields And Completed All TC/FND"
      );
    }

    return isValid;
  };

  const forceHideTooltips = () => {
    const tooltips = document.querySelectorAll(".MuiTooltip-tooltip");
    tooltips.forEach((tooltip) => {
      const parent = tooltip.parentElement;
      if (parent) {
        parent.removeChild(tooltip);
      }
    });
  };

  const handleDeleteTask = (id) => {
    setWPCards((prevCards) => prevCards.filter((card) => card.id !== id));
  };

  const createNewTC = () => {
    if (WPSelected === null) {
      warningMsg(
        "No Work Package Selected",
        "Please Select a Work Package First",
        4000
      );
      return;
    } else {
      setWPCards((prevState) => {
        const newCard = {
          id: Date.now(),
          companyId: selectedCompany,
          taskCardId: -1,
          findingId: null,
          partRequestDetailParts: [],
        };
        // Asegurándonos de que prevState sea un array antes de usar el spread operator
        return Array.isArray(prevState) ? [...prevState, newCard] : [newCard];
      });
    }
  };

  const updatePartRequestDetailParts = (index, newPartRequestDetailParts) => {
    setWPCards((prevState) => {
      const updatedCards = [...prevState];
      updatedCards[index].partRequestDetailParts = newPartRequestDetailParts;
      return updatedCards;
    });
  };

  const updateTaskCardId = (index, newTaskCardId) => {
    setWPCards((prevState) => {
      const updatedCards = [...prevState];
      updatedCards[index].taskCardId = newTaskCardId;
      return updatedCards;
    });
  };

  const createNewFND = () => {
    if (WPSelected === null) {
      warningMsg(
        "No Work Package Selected",
        "Please Select a Work Package First",
        4000
      );
      return;
    } else {
      setWPCards((prevState) => {
        const newCard = {
          id: Date.now(),
          companyId: selectedCompany,
          taskCardId: null,
          findingId: -1,
          partRequestDetailParts: [],
        };
        return [...prevState, newCard];
      });
    }
  };

  const updateFindingId = (index, newFindingId) => {
    setWPCards((prevState) => {
      const updatedCards = [...prevState];
      updatedCards[index].findingId = newFindingId;
      return updatedCards;
    });
  };

  const preloadForm = (data) => {
    // preselection dropdowns
    setPreselectCompany(data?.companyId ? data?.companyId : null);
    setPreselectLocation(data?.locationId ? data?.locationId : null);
    setPreselectSite(data?.siteId ? data?.siteId : null);
    setPreselectAircraft(data?.aircraftId ? data?.aircraftId : null);
    setPreselectWP(data?.workPackageId ? data?.workPackageId : null);
    setPreselectCustomer(data?.customerId ? data?.customerId : null);
    setPreselectPriority(data?.priority ? data?.priority : null);

    // selection values of dropdowns ( preselection isn't emmiting onOptionselection event)
    setSelectedCompany(data?.companyId ? data?.companyId : null);
    setLocationSelected(data?.locationId ? data?.locationId : null);
    setSiteSelected(data?.siteId ? data?.siteId : null);
    setAircraftSelected(data?.aircraftId ? data?.aircraftId : null);
    setWPSelected(data?.workPackageId ? data?.workPackageId : null);
    setCustomerSelected(data?.customerId ? data?.customerId : null);
    setPrioritySelected(data?.priority ? data?.priority : null);
    //more states preselection
    // setDateRequiredSelected(
    //   data?.dateRequestRequired &&  ? data?.dateRequestRequired : null
    // );
    setDateRequestedCreated(
      data?.dateRequestCreated ? data?.dateRequestCreated : null
    );
    setPRN(data?.id ? data?.id : null);
    // setWPCards(data?.partRequestDetails ? data?.partRequestDetails : null); // este es el states de los taskcard

    if (data?.partRequestDetailParts) {
      const groupedCards = {};

      data.partRequestDetailParts.forEach((part) => {
        const groupKey = part.taskCardId ?? part.findingId;

        if (!groupedCards[groupKey]) {
          groupedCards[groupKey] = {
            id: groupKey,
            companyId: data.companyId,
            taskCardId: part.taskCardId,
            findingId: part.findingId,
            partRequestDetailParts: [],
          };
        }
        groupedCards[groupKey].partRequestDetailParts.push(part);
      });

      const wpcardsData = Object.values(groupedCards);
      setWPCards(wpcardsData);
    } else {
      setWPCards(null);
    }
    setVersion(data?.version ? data?.version : 0);
  };

  const getDataToEdit = async () => {
    let request = await getPRNEditionForm(requestId);
    if (request.data.responseCode == HTTP_RESPONSE_CODES.UPDATED) {
      preloadForm(request.data.load);
      setPrnStatus(request.data.load.status);
    }
  };

  const getPermissionsToSave = async () => {
    let request = await getPermissions(17);

    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setHasPermissionsToPost(
        request.data.load.some((action) => action.key === "saveP")
      );
      setHasPermissionsToDraft(
        request.data.load.some((action) => action.key === "saveD")
      );
      setHasPermissionsToTC(
        request.data.load.some((action) => action.key === "addTC")
      );
      setHasPermissionsToFND(
        request.data.load.some((action) => action.key === "addF")
      );
    }
  };
  const isProcessing = useRef(null);
  // useEffects
  function generateUUID() {
    return crypto.randomUUID();
  }
  useEffect(() => {
    getAllDropdowns();
    if (formMode && requestId) {
      if (formMode == "edit") {
        getDataToEdit();
      }
    }
    dispatch(
      addTab({
        icon: "icon-part_request_icon",
        color: "#6ac24f",
        path: "/store/new-part-request",
        title: "New Part Request",
        isPinned: false,
        componentKey: "NewPartRequest",
        id: -1,
        isModule: false,
        date: generateUUID(),
      })
    );

    getPermissionsToSave();
  }, []);

  const saveToDraft = async () => {
    if (!hasPermissionsToDraft) {
      warningMsg(
        "Warning",
        "You don't have permissions to save the PRN in Draft"
      );
      return;
    }

    if (!ValidateForm()) {
      warningMsg(
        "Fields required",
        "Make Sure You Have Selected All Fields And Completed All TC/FND"
      );
    }

    // Usar valores actuales del estado
    const currentForm = form;
    const currentPRN = PRN;

    let request;
    if (currentPRN) {
      request = await savePartRequest({
        ...currentForm,
        status: "Draft",
      });
    } else {
      request = await createPartRequest({
        ...currentForm,
        status: "Draft",
      });
    }

    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setVersion(request.data.load.version);
      setForm((prevData) => {
        return { ...prevData, version: request.data.load.version };
      });
      successMsg(
        "Saved In Draft",
        "The data has been Saved In Draft Successfully And The PRN Has Been Established",
        5000
      );
      setPRN(request.data.load.id);
      setPrnStatus(request.data.load.status);
    } else {
      errorMsg("Error", "There was an error saving the data");
    }
  };

  // const postData = async () => {
  //   if (!ValidateForm()) {
  //     return;
  //   }
  //   forceHideTooltips();
  //   let request;

  //   if (PRN) {
  //     //aqui inicia el error
  //     request = await savePartRequest({
  //       ...form,
  //       status: "Posted",
  //     });
  //   } else {
  //     request = await createPartRequest({
  //       ...form,
  //       status: "Posted",
  //     });
  //   }

  //   if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
  //     setVersion(0);
  //     // setForm(null);
  //     setPRN(null);
  //     successMsg(
  //       "Saved",
  //       "The data has been Saved Successfully And The PRN Has Been Established",
  //       5000
  //     );
  //     notifySaved();
  //     dispatch(setActiveTab("/store/part-request-management"));
  //     dispatch(closeTab("/store/new-part-request"));
  //     // navigate(basePath + "/store/part-request-management");
  //     window.history.pushState(
  //       null,
  //       "",
  //       basePath + "/store/part-request-management"
  //     );
  //   } else {
  //     errorMsg("Error", "There was an error saving the data");
  //   }
  // };

  const postData = async () => {
    if (isProcessing.current) return;
    if (!hasPermissionsToPost) {
      warningMsg("Warning", "You don't have permissions to Post This PRN");
      return;
    }

    // Validación local

    if (!ValidateForm() || !form) {
      return;
    }

    isProcessing.current = true;
    forceHideTooltips();

    // Usar valores actuales del estado
    const currentForm = form;
    const currentPRN = PRN;

    try {
      let request;

      if (currentPRN) {
        request = await savePartRequest({ ...currentForm, status: "Posted" });
      } else {
        request = await createPartRequest({ ...currentForm, status: "Posted" });
      }

      if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
        setVersion(request.data.load.version);
        setForm(null);
        setPRN(null);
        successMsg(
          "Saved",
          "The data has been Saved Successfully " +
            "PRN : " +
            request.data.load.id,
          5000
        );
        notifySaved();
        dispatch(setActiveTab("/store/part-request-management"));
        dispatch(closeTab("/store/new-part-request"));
        window.history.pushState(
          null,
          "",
          basePath + "/store/part-request-management"
        );
      } else {
        errorMsg("Error", "There was an error saving the data");
      }
    } catch (error) {
      errorMsg("Error", "There was an error saving the data");
    } finally {
      isProcessing.current = false;
    }
  };

  // const handleKeyDown = useCallback((event) => {
  //   if (event.ctrlKey && event.key.toLowerCase() === "s") {
  //     event.preventDefault();
  //     if (hasPermissionsToDraft) {
  //       saveToDraft();
  //     } else {
  //       warningMsg("Warning", "You don't have permissions to save the PRN in Draft");
  //     }
  //   }

  //   if (event.ctrlKey && event.key.toLowerCase() === "g") {
  //     event.preventDefault();
  //     if (hasPermissionsToPost && validateTcAndPNData(WPCards)) {
  //       postData();
  //     } else {
  //       warningMsg("Warning", "The form could not be submitted. Please try again.", 5000);
  //     }
  //   }
  // }, [hasPermissionsToDraft, hasPermissionsToPost, WPCards, saveToDraft, postData , validateTcAndPNData]);

  // useEffect(() => {
  //   document.addEventListener("keydown", handleKeyDown);
  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, [handleKeyDown]);

  // useEffect(() => {
  //   if (isKeyDownListenerAttached) return;

  //   keyDownHandler = (event) => {
  //     if (event.ctrlKey || event.metaKey) {
  //       const key = event.key.toLowerCase();

  //       if (key === "s") {
  //         event.preventDefault();
  //         saveToDraft();
  //       }

  //       if (key === "g") {
  //         event.preventDefault();
  //         postData();
  //       }
  //     }
  //   };

  //   document.addEventListener("keydown", keyDownHandler);
  //   isKeyDownListenerAttached = true;
  //   console.log("🟢 Global keydown listener attached");

  //   return () => {
  //     if (isKeyDownListenerAttached && keyDownHandler) {
  //       document.removeEventListener("keydown", keyDownHandler);
  //       isKeyDownListenerAttached = false;
  //       keyDownHandler = null;
  //       console.log("🔴 Global keydown listener removed");
  //     }
  //   };
  // }, []);
  useEffect(() => {
    setDataCompanyDrop(() => JSON.parse(localStorage.getItem("u_companies")));
    setForm(() => {
      return {
        id: parseInt(PRN),
        companyId: parseInt(selectedCompany),
        locationId: parseInt(locationSelected),
        siteId: parseInt(siteSelected),
        aircraftId: parseInt(aircraftSelected),
        workPackageId: parseInt(WPSelected),
        dateRequestCreated: dateRequestedCreated,
        dateRequestRequired: dateRequiredSelected,
        customerId: parseInt(customerSelected),
        priority: prioritySelected,
        description: "",
        status: "Draft",
        version: version,
        partRequestType: "Workpackage",
        partRequestDetailParts:
          WPCards?.length > 0
            ? WPCards.flatMap((card) => {
                return (
                  card.partRequestDetailParts?.map((part) => {
                    const { id: partId = null, ...restPart } = part;
                    return restPart;
                  }) || []
                );
              })
            : [],
      };
    });

    let interval;
    if (!formMode || formMode !== "edit") {
      interval = setInterval(() => {
        setDateRequestedCreated(new Date());
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [
    selectedCompany,
    locationSelected,
    siteSelected,
    aircraftSelected,
    WPSelected,
    // dateRequestedCreated,
    dateRequiredSelected,
    customerSelected,
    WPCards,
    version,
    PRN,
    prioritySelected,
  ]);

  // dropdowns calbacks

  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    updateWPSelectionContext(dropdownId, parentValues, dependenciesToUpdate);

    let setDropdown;

    switch (dropdownId) {
      case 17:
        setDropdown = setLocationDrop;
        break;
      case 19:
        setDropdown = setSiteDrop;
        break;
      case 65:
        setDropdown = setWPDrop;
        break;
      case 66:
        setDropdown = setAircraftDrop;
        break;
      default:
        return;
    }

    const debounceUpdate = setTimeout(() => {
      setDropdown((prevState) => ({
        ...prevState,
        parentValues,
        dependenciesToUpdate,
        reload: true,
      }));
    }, 200);

    return () => clearTimeout(debounceUpdate);
  };

  const resetDropdownsReload = () => {
    setLocationDrop((prevState) => ({ ...prevState, reload: false }));
    setSiteDrop((prevState) => ({ ...prevState, reload: false }));
    setAircraftDrop((prevState) => ({ ...prevState, reload: false }));
    setWPDrop((prevState) => ({ ...prevState, reload: false }));
  };

  const getCompanySelection = (selectedValues) => {
    setSelectedCompany(selectedValues.id);
    setPreselectCompany(selectedValues.id);
    setPreselectLocation(null);
    setPreselectSite(null);
    setPreselectAircraft(null);
    setPreselectWP(null);
    setPreselectCustomer(null);
    setPrioritySelected(null);

    setLocationSelected(null);
    setSiteSelected(null);
    setAircraftSelected(null);
    setWPSelected(null);
    setCustomerSelected(null);
    setPreselectPriority(null);
    setWPCards(() => {
      return [];
    });
  };

  const getLocationSelection = (selectedValues) => {
    setLocationSelected(selectedValues.id);
    setPreselectLocation(selectedValues.id);
    setPreselectSite(null);
    setPreselectWP(null);
    // setPreselectAircraft(null)
    // setPreselectCustomer(null)
  };

  const getSiteSelection = (selectedValues) => {
    setSiteSelected(selectedValues.id);
    setPreselectSite(selectedValues.id);
    setPreselectWP(null);
    // setPreselectAircraft(null)
    // setPreselectCustomer(null)
  };

  const getAircraftSelection = (selectedValues) => {
    setAircraftSelected(selectedValues.id);
    setPreselectAircraft(selectedValues.id);
    // setPreselectWP(null);
  };

  const getWPSelection = (selectedValues) => {
    setWPSelected(selectedValues.id);
    setPreselectWP(selectedValues.id);
    setPreselectLocation(selectedValues.location_id);
    setPreselectSite(selectedValues.site_id);
    setLocationSelected(selectedValues.location_id);
    setSiteSelected(selectedValues.site_id);
    setPreselectAircraft(selectedValues.aircraft_id);
    setAircraftSelected(selectedValues.aircraft_id);
    setPreselectCustomer(selectedValues.customer_id);
    setCustomerSelected(selectedValues.customer_id);
    setPrioritySelected(selectedValues.priority);
    setPreselectPriority(selectedValues.priority);

    setWPCards(() => {
      return [];
    });
  };
  const getPrioritySelection = (selectedValues) => {
    setPrioritySelected(selectedValues.name);
  };

  const getDateRequiredSelection = (selectedValues) => {
    setDateRequiredSelected(selectedValues.$d);
  };

  const getCustomerSelection = (selectedValues) => {
    setCustomerSelected(selectedValues.id);
  };

  const handleCompanyClear = () => {
    setPreselectCompany(null);
    setSelectedCompany(null);

    setPreselectWP(null);
    setWPSelected(null);

    setLocationSelected(null);
    setPreselectLocation(null);

    setSiteSelected(null);
    setPreselectSite(null);

    setAircraftSelected(null);
    setPreselectAircraft(null);

    setCustomerSelected(null);
    setPreselectCustomer(null);
    setWPCards([]);
  };

  const handleAircraftClear = () => {
    setAircraftSelected(null);
    setPreselectAircraft(null);
  };

  const handleWPClear = () => {
    setPreselectWP(null);
    setWPSelected(null);

    setWPCards([]);

    setLocationSelected(null);
    setPreselectLocation(null);

    setSiteSelected(null);
    setPreselectSite(null);

    setPreselectAircraft(null);
    setAircraftSelected(null);

    setCustomerSelected(null);
    setPreselectCustomer(null);
  };

  const handleCustomerClear = () => {
    setCustomerSelected(null);
    setPreselectCustomer(null);
  };

  const goBackDataObj = {
    icon: "icon-part_request_icon",
    color: "#6AC24F ",
    path: "/store/part-request-management",
    title: "Part Request Management",
    isPinned: false,
    componentKey: "PartRequest",
    id: 15,
    isModule: false,
    date: generateUUID(),
  };

  return (
    <>
      <main className="new-part-request">
        <section className="new-part-request-top-section">
          <NavBar
            dataBreadCrumbs={"/store/part-request-management/new-part-request"}
            appIcon={"icon-part_request_icon"}
            moduleIcon={"icon-settings"}
            moduleColor="#6ac24f"
            title={
              formMode === "edit" ? "Edit Part Request" : "New Part Request"
            }
            menuTitle={"Store Options"}
            moduleId={3}
            goBackData={goBackDataObj}
            needClearTab={true}
            currentPath={"/store/new-part-request"}
          />
        </section>
        <section className="new-part-request-bottom-section">
          <div className="new-part-request-general-info">
            <div>
              <h3
                style={{
                  marginRight: prnStatus !== "Draft" ? "auto" : "0px",
                }}
              >
                General Information
              </h3>
              {prnStatus === "Draft" && (
                <span>
                  <i className="icon-status-draft"></i>
                  <p>Status: Draft</p>
                </span>
              )}

              {hasPermissionsToDraft && (
                // <Tooltip title="Ctrl + S To Save In draft" arrow>
                  <button
                    onClick={(e) => {
                      saveToDraft();
                    }}
                  >
                    <i className="icon-save"></i>
                    Save Draft
                  </button>
                // </Tooltip>
              )}
              {hasPermissionsToPost && (
                // <Tooltip title="Ctrl + G To Post" arrow>
                  <button
                    style={{
                      background: disablePostBtn
                        ? "var(--grey-200)"
                        : "#00CE88",
                      opacity: disablePostBtn ? 0.5 : 1,
                      cursor: disablePostBtn ? "no-drop" : "pointer",
                    }}
                    onClick={postData}
                    disabled={disablePostBtn}
                  >
                    <img src={iconSend} alt="" />
                    Post
                  </button>
                // </Tooltip>
              )}
            </div>
            <section className="new-part-request-general-info-inp-cont">
              <div>
                <Input
                  value={PRN ? PRN : "--"}
                  isNumeric={true}
                  label={"PRN"}
                  type="text"
                  placeholder="PRN"
                  disabled={true}
                />
              </div>
              <div>
                {companyDrop ? (
                  <Dropdowns
                    //  handleClear={handleCompanyClear}
                    showWarningModal={WPCards?.length > 0}
                    warningMessagge={
                      "Are you sure you want to change the selected company? If you continue, this will reset the selected data."
                    }
                    onOptionSelect={getCompanySelection}
                    updateDropdown={updateDropdown}
                    resetDropdownsReload={resetDropdownsReload}
                    preSelectValue={preselectCompany}
                    staticDataColumnPreselection={"id"}
                    isStatic={true}
                    staticData={dataCompanyDrop}
                    data={companyDrop}
                    required={true}
                    activateErrorHint={hasCompanyError}
                    handleClear={handleCompanyClear}
                  ></Dropdowns>
                ) : (
                  <Skeleton height="2rem" width="100%" />
                )}
              </div>
              <div>
                {WPDrop ? (
                  <Dropdowns
                    warningMessagge={
                      "You will change the WP Selected , This Change Will Affect The Taskcards Or Findings than you have been working on"
                    }
                    preSelectValue={preselectWP}
                    showWarningModal={WPCards?.length > 0}
                    activateErrorHint={hasWPError}
                    updateDropdown={updateDropdown}
                    resetDropdownsReload={resetDropdownsReload}
                    onOptionSelect={getWPSelection}
                    data={WPDrop}
                    required={true}
                    handleClear={handleWPClear}
                  ></Dropdowns>
                ) : (
                  <Skeleton height="2rem" width="100%" />
                )}
              </div>
              <div
              // style={{
              //   gridColumn: "span 2",
              // }}
              >
                {priorityDrop ? (
                  <Dropdowns
                    preSelectValue={preselectPriority}
                    onOptionSelect={getPrioritySelection}
                    data={priorityDrop}
                  ></Dropdowns>
                ) : (
                  <Skeleton height="2rem" width="100%" />
                )}
              </div>
              <div>
                {locationDrop ? (
                  <Dropdowns
                    warningMessagge={
                      "You will change the location , this change will affect  the selection of the site , aircraft , WorkPackage and The Taskcards / Findings than you have selected"
                    }
                    activateErrorHint={hasLocationError}
                    // handleClear={handleLocationClear}
                    preSelectValue={preselectLocation}
                    onOptionSelect={getLocationSelection}
                    // updateDropdown={updateDropdown}
                    // resetDropdownsReload={resetDropdownsReload}
                    data={locationDrop}
                    required={true}
                    disabled={true}
                  ></Dropdowns>
                ) : (
                  <Skeleton height="2rem" width="100%" />
                )}
              </div>
              <div>
                {siteDrop ? (
                  <Dropdowns
                    // handleClear={handleSiteClear}
                    preSelectValue={preselectSite}
                    activateErrorHint={hasSiteError}
                    onOptionSelect={getSiteSelection}
                    // updateDropdown={updateDropdown}
                    // resetDropdownsReload={resetDropdownsReload}
                    data={siteDrop}
                    required={true}
                    disabled={true}
                  ></Dropdowns>
                ) : (
                  <Skeleton height="2rem" width="100%" />
                )}
              </div>
              <div>
                {aircraftDrop ? (
                  <Dropdowns
                    handleClear={handleAircraftClear}
                    preSelectValue={preselectAircraft}
                    // updateDropdown={updateDropdown}
                    // resetDropdownsReload={resetDropdownsReload}
                    onOptionSelect={getAircraftSelection}
                    data={aircraftDrop}
                    disabled={true}
                  ></Dropdowns>
                ) : (
                  <Skeleton height="2rem" width="100%" />
                )}
              </div>

              <div>
                <BasicDatePicker
                  onChange={getDateRequiredSelection}
                  value={dateRequiredSelected}
                  label={"Date Required"}
                  isRequired={true}
                  disablePastDates={true}
                ></BasicDatePicker>
              </div>
              <div>
                <BasicDatePicker
                  value={dateRequestedCreated}
                  isDateTime={true}
                  disabled={true}
                  isRequired={true}
                  label={"Date Request Created"}
                  disablePastDates={true}
                ></BasicDatePicker>
              </div>
              <div
              // style={{
              //   gridColumn: "span 2",
              // }}
              >
                {customerDrop ? (
                  <Dropdowns
                    // handleClear={handleCustomerClear}
                    preSelectValue={preselectCustoner}
                    onOptionSelect={getCustomerSelection}
                    data={customerDrop}
                    disabled={true}
                  ></Dropdowns>
                ) : (
                  <Skeleton height="2rem" width="100%" />
                )}
              </div>

              <div
              // style={{
              //   gridColumn: "span 2",
              // }}
              >
                {requestTypeDrop ? (
                  <Dropdowns
                    preSelectValue={1}
                    disabled={true}
                    data={requestTypeDrop}
                  ></Dropdowns>
                ) : (
                  <Skeleton height="2rem" width="100%" />
                )}
              </div>
            </section>
            <section className="new-part-request-general-info-tc-fnd-cont">
              <h3>Task Cards / Findings</h3>

              <div>
                <input type="text" placeholder="Search" />
                <i className="icon-search"></i>
              </div>

              <section>
                {hasPermissionsToTC && (
                  <button onClick={createNewTC}>
                    <i className="icon-task_icon_partRequest icon_TC_new_request"></i>{" "}
                    Add Task Card
                  </button>
                )}
                {hasPermissionsToFND && (
                  <button onClick={createNewFND}>
                    <i className="icon-finding_error_icon icon_FND_new_request"></i>{" "}
                    Add Finding
                  </button>
                )}
              </section>
            </section>
          </div>
          <PermissionsProvider resourceId={17}>
            <div className="new-part-request-cards-cont">
              {WPCards?.length > 0 ? (
                WPCards.map((card, idx) => {
                  return (
                    <NewPartRequestTC
                      WPId={WPSelected}
                      key={card.id}
                      index={idx}
                      updateTaskCardId={
                        card.taskCardId ? updateTaskCardId : undefined
                      }
                      updateFindingId={
                        card.findingId ? updateFindingId : undefined
                      }
                      taskCardId={card.taskCardId}
                      findingId={card.findingId}
                      updatePartRequestDetailParts={
                        updatePartRequestDetailParts
                      }
                      companyId={selectedCompany}
                      initialData={card}
                      deleteCard={handleDeleteTask}
                      PRNStatus={prnStatus}
                    />
                  );
                })
              ) : (
                <div className="new-part-request-cards-cont-msg">
                  <i className="icon-info"></i>
                  <p>
                    To add a Task Card or Finding, please select a Work Package
                    (WP) first.
                  </p>
                </div>
              )}
            </div>
          </PermissionsProvider>
        </section>
      </main>
    </>
  );
};
